import { render } from "./ControlTable.vue?vue&type=template&id=cfc66ba8"
import script from "./ControlTable.vue?vue&type=script&lang=js"
export * from "./ControlTable.vue?vue&type=script&lang=js"

import "./ControlTable.vue?vue&type=style&index=0&id=cfc66ba8&lang=css"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__